var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rb-footer-mention-me-link" }, [
    _c("div", { staticClass: "rb-footer-mention-me-link__title" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.translation("mention_me.footer_link.title")) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "rb-btn rb-btn--black rb-footer-mention-me-link__button",
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.onMentionMeFooterButtonClick($event)
          },
        },
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(_vm.translation("mention_me.footer_link.button")) +
            "\n  "
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }